import * as Sentry from "@sentry/browser";
import { default as React } from "react";
import "react-app-polyfill/ie11";
import ReactDom from "react-dom";
import List from "../components/List";
Sentry.init({
    dsn: process.env.SENTRY_DSN,
    release: process.env.VERSION,
});
ReactDom.render(React.createElement(List, { type: "brand", lang: document.location.pathname.includes("/ja/") ? "ja" : "en", branch: document.location.pathname.includes("hamamatsu") ? "hamamatsu" : "jingumae" }), document.getElementById("Brand"));
